<!--  -->
<template>
  <div class="Indexmain">
    <div class="product section">
      <div class="product-main">
        <div class="product-box">
          <h1>
            {{ product.title }}
          </h1>
          <ul class="product-list">
            <li v-for="(item, key) in productList" :key="key">
              <router-link :to="item.url">
                <div class="product-list_img">
                  <img :src="item.src" />
                </div>
                <p>{{ item.title }}</p>
              </router-link>
            </li>
          </ul>
          <div class="product-more">
            <router-link to="/product">
              {{ lookmore }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="about section">
      <transition name="fade">
        <div class="about-main" v-show="aboutShow">
          <h1>{{ about.title }}</h1>
          <p>{{ about.content }}</p>
          <div class="about-more">
            <router-link to="/aboutUs">
              {{ lookmore }}
            </router-link>
          </div>
        </div>
      </transition>
    </div>
    <div class="news section">
      <div class="news-main">
        <div class="news-photo">
          <img :src="news.src" width="610" height="445" />
        </div>
        <div class="news-content">
          <h1>{{ news.title }}</h1>
          <p>{{ news.content }}</p>
          <div class="news-more">
            <router-link to="/news">
              {{ lookmore }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="join section">
      <div class="join-main">
        <h1>{{ join.title }}</h1>
        <p>{{ join.content }}</p>
        <ul class="join-list" v-if="joinShow">
          <li v-for="(item, key) in joinList" :key="key">
            <div class="join-logo">
              <img class="imgontrol" :src="item.src" />
            </div>
            <h2>{{ item.title }}</h2>
          </li>
        </ul>
        <div class="join-more">
          <router-link to="/joinUs">
            {{ lookmore }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="section"></div>
    <div class="right-nav">
      <ul class="right-ul">
        <li
          v-for="(item, index) in right_nav"
          :key="index"
          :class="[item.class, { here: index === onSelect }]"
          @click="jump(index, $event)"
        >
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import anime from "animejs";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 右侧导航
      scroll: "",
      onSelect: 0,
      right_nav: [
        {
          class: "shouye",
          title: "", //首页
        },
        {
          class: "chanpin",
          title: "", //产品中心
        },
        {
          class: "guanyu",
          title: "", //公司简介
        },
        {
          class: "xinwen",
          title: "", //新闻中心
        },
        {
          class: "zhaoxian",
          title: "", //招贤纳士
        },
      ],
      // 产品中心数据
      product: {
        title: "",
      },
      productList: [
        /* 
        {
          title: "导航",
          src: require("../assets/daohang.png"),
        },
        {
          title: "诊断",
          src: require("../assets/zhenduan.png"),
        },
        {
          title: "治疗",
          src: require("../assets/zhiliao.png"),
        },
       */
      ],
      //关于堃博
      about: {
        title: "",
        content: "",
      },
      //新闻中心
      news: {
        title: "",
        src: "",
        content: "",
      },
      //招贤纳士
      join: {
        title: "",
        content: "",
      },
      joinList: [
        /* 
        {
          title: "体检",
          src: require("../assets/tijian.png"),
        },
        {
          title: "体检",
          src: require("../assets/tijian.png"),
        },
        {
          title: "体检",
          src: require("../assets/tijian.png"),
        },
        {
          title: "体检",
          src: require("../assets/tijian.png"),
        },
        {
          title: "体检",
          src: require("../assets/tijian.png"),
        },
        {
          title: "体检",
          src: require("../assets/tijian.png"),
        },
       */
      ],
      aboutShow: false,
      lookmore: "", //查看更多
      joinShow: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    boxrun() {
      anime({
        targets: ".product-box",
        translateX: 400,
      });
    },
    newsrun() {
      anime({
        targets: ".news-main",
        translateY: -250,
      });
    },
    showIcon() {
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 400
      ) {
        this.boxrun();
      }
      if (document.documentElement.scrollTop > 600) {
        this.aboutShow = true;
      }
      if (document.documentElement.scrollTop > 1400) {
        this.newsrun();
      }
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.lookmore = obj.data["ckgd"];
            that.right_nav[0].title = obj.data["sy"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //1.产品中心
    get_data1() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 4,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.product.title = obj.yj_name;
            that.right_nav[1].title = obj.yj_name;
            if (obj.region == 2) {
              $.each(obj.data, function (i, k) {
                if (i < 2) {
                  that.productList.push({
                    title: k.title,
                    src: k.pic_sy,
                    url: k.url,
                  });
                }
              });
            } else {
              $.each(obj.data, function (i, k) {
                if (i < 3) {
                  that.productList.push({
                    title: k.title,
                    src: k.pic_sy,
                    url: k.url,
                  });
                }
              });
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.关于堃博
    get_data2() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_article",
          article_id: 3,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.about.title = obj.data["title"];
            that.about.content = obj.data["description"];
            that.right_nav[2].title = obj.data["title"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //3.新闻中心
    get_data3() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 5,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.news.title = obj.yj_name;
            that.news.content = obj.yj_description;
            that.right_nav[3].title = obj.yj_name;
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //4.新闻中心(最新1张新闻图片)
    get_data4() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 33,
          sort_type: "create_time",
          sort: "desc",
          show_num: 1,
          xiaji: 1,
          biaoshi: "index",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.news.src = obj.data[0].pic_f; //最新的新闻配图
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //5.招贤纳士
    get_data5() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 6,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (!obj.region) {
            that.joinShow = true;
          } else {
            that.joinShow = false;
          }
          if (obj.code == "0000") {
            that.join.title = obj.yj_name;
            that.join.content = obj.yj_description;
            that.right_nav[4].title = obj.yj_name;
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //6.公司福利
    get_data6() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 16,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              that.joinList.push({
                title: k.title,
                src: k.pic_f,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //右侧导航
    dataScroll: function () {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    jump(index) {
      this.onSelect = index;
      let jump = document.querySelectorAll(".section");
      // 获取需要滚动的距离
      let total = jump[index].offsetTop - "900";
      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
      // $("html, body").animate(
      //   {
      //     scrollTop: total,
      //   },
      //   400
      // );
    },
    loadSroll: function () {
      var self = this;
      var $navs = $(".right-ul li");
      var sections = document.getElementsByClassName("section");
      for (var i = sections.length - 1; i >= 0; i--) {
        if (self.scroll >= sections[i].offsetTop - 1100) {
          $navs.eq(i).addClass("here").siblings().removeClass("here");
          break;
        }
      }
    },
  },
  watch: {
    scroll: function () {
      this.loadSroll();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.get_fanyi();
    this.get_data1();
    this.get_data2();
    this.get_data3();
    this.get_data4();
    this.get_data5();
    this.get_data6();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener("scroll", this.showIcon);

    window.addEventListener("scroll", this.dataScroll);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.Indexmain {
  width: 100%;
  background: url("../assets/Indexbg1.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .right-nav {
    position: fixed;
    top: 40%;
    z-index: 100;
    right: 8%;
    height: 330px;
    width: 1px;
    background-color: #fff;
    ul {
      position: absolute;
      left: -3px;
      li {
        cursor: pointer;
        width: 7px;
        height: 7px;
        background: #ffffff;
        position: absolute;
        border-radius: 50%;
        transition: 0.2s;
        span {
          left: 24px;
          top: -10px;
          position: absolute;
          display: inline-block;
          color: #fff;
          width: 100px;
          font-size: 1rem;
          opacity: 0;
          transition: 0.3s;
        }
        .spanShow {
          opacity: 1;
        }
      }
      .shouye {
        top: 0;
      }
      .chanpin {
        top: 82px;
      }
      .guanyu {
        top: 164px;
      }
      .xinwen {
        top: 246px;
      }
      .zhaoxian {
        top: 328px;
      }
      .here {
        width: 19px;
        height: 19px;
        border: 4px solid #ffffff;
        border-radius: 50%;
        left: -6px;
        background: #0e499a;
        span {
          opacity: 1;
        }
      }
    }
  }

  .product {
    width: 100%;
    height: 814px;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.4);
    .product-main {
      width: $main-width;
      margin: 0 auto;
      .product-box {
        width: 60%;
        text-align: center;
        padding-top: 180px;
        position: relative;
        left: -400px;
        h1 {
          font-size: 2.5rem;
          color: #193895;
        }
        .product-list {
          // display: flex;
          // justify-content: space-around;
          text-align: center;
          margin-top: 60px;
          li {
            display: inline-block;
            margin: 0 30px;
          }
          .product-list_img {
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          p {
            margin-top: 14px;
            font-size: 1.8rem;
            color: #193895;
          }
        }
        .product-more {
          width: 387px;
          background: #ffc90f;
          border-radius: 20px;
          margin: 40px auto 0;
          padding: 10px 0;
          a {
            display: inline-block;
            width: 100%;
            height: 100%;
            color: $text-color;
            font-size: 1.8rem;
          }
        }
      }
    }
  }
  .about {
    width: 100%;
    height: auto;
    background: url("../assets/feiBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.4);
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 1s;
    }
    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
    .about-main {
      width: 1300px;
      margin: 0 auto 150px;
      text-align: center;
      padding-top: 150px;
      h1 {
        font-size: 2.5rem;
        color: $text-color;
      }
      p {
        display: block;
        margin: 40px auto 0;
        // width: 75%;
        font-size: 2rem;
        color: $text-color;
        line-height: 1.5;
      }
      .about-more {
        width: 387px;
        background: #ffc90f;
        border-radius: 20px;
        margin: 40px auto 0;
        padding: 10px 0;
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
          color: $text-color;
          font-size: 1.8rem;
        }
      }
    }
  }
  .news {
    width: 100%;
    height: 749px;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.4);
    .news-main {
      width: $main-width;
      margin: 0 auto;
      padding: 150px 0;
      display: flex;
      justify-content: space-between;
      position: relative;
      top: 250px;
      .news-photo {
        width: 580px;
        height: 445px;
        border-radius: 3px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
      .news-content {
        width: 600px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        h1 {
          margin-top: 120px;
          font-size: 2.5rem;
          color: $text-color;
          text-align: right;
        }
        p {
          margin-top: 42px;
          font-size: 2rem;
          color: $text-color;
          font-weight: 200;
          text-align: right;
        }
        .news-more {
          width: 387px;
          background: #ffc90f;
          border-radius: 20px;
          margin: 40px 0;
          margin-left: auto;
          padding: 10px 0;
          text-align: center;
          a {
            display: inline-block;
            width: 100%;
            height: 100%;
            color: $text-color;
            font-size: 1.8rem;
          }
        }
      }
    }
  }
  .join {
    width: 100%;
    height: auto;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.4);
    .join-main {
      width: $main-width;
      margin: 0 auto 120px;
      text-align: center;
      padding-top: 75px;
      h1 {
        color: $text-color;
        font-size: 2.5rem;
      }
      p {
        margin-top: 40px;
        font-size: 2rem;
        color: $text-color;
        font-weight: 200;
        line-height: 1.5;
      }
      .join-list {
        margin-top: 126px;
        display: flex;
        justify-content: space-between;
        li {
          text-align: center;
          .join-logo {
            width: 50px;
            margin: 0 auto;
            height: 50px;
            text-align: center;
            img {
              width: 100%;
              height: 100%;
            }
          }
          h2 {
            margin-top: 16px;
            font-size: 1.5rem;
            color: $text-color;
          }
        }
      }
      .join-more {
        width: 387px;
        background: #ffc90f;
        border-radius: 20px;
        margin: 40px auto 0;
        padding: 10px 0;
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
          color: $text-color;
          font-size: 1.8rem;
        }
      }
    }
  }
}
@media screen and (max-width: 1430px) {
  .Indexmain .news {
    .news-main {
      .news-content {
        padding-right: 60px;
      }
    }
  }
}
@media screen and (max-width: 1320px) {
  .Indexmain .about .about-main {
    width: 100%;
  }
}
@media screen and (max-width: $main-width) {
  .Indexmain {
    .right-nav {
      display: none;
    }
    .product {
      height: auto;
      padding-bottom: 20px;
      .product-main {
        width: 100%;
        .product-box {
          padding-top: 20px;
          left: -300px;
          .product-more {
            width: 90%;
            margin: 20px auto;
          }
          .product-list {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
          }
        }
      }
    }
    .about {
      .about-main {
        width: 100%;
        padding-top: 60px;
        p {
          width: 100%;
          padding: 0 20px;
        }
        .about-more {
          width: 90%;
          margin: 0 auto;
        }
      }
    }

    .news {
      height: auto;
      .news-main {
        width: 100%;
        flex-wrap: wrap;
        padding: 60px 0;
        .news-photo {
          width: 100%;
          height: auto;
          padding: 0 10px;
          margin: 0 auto;
          img {
            width: 100%;
          }
        }
        .news-content {
          width: 100%;
          margin: 0 auto;
          padding-right: 0;
          h1 {
            margin-top: 60px;
            text-align: center;
          }
          p {
            text-align: center;
          }
          .news-more {
            width: 90%;
            margin: 20px auto;
          }
        }
      }
    }

    .join {
      height: auto;
      .join-main {
        width: 100%;
        padding-bottom: 40px;
        .join-list {
          width: 100%;
          padding: 0 10px;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            width: 30%;
            margin-top: 10px;
          }
        }
        .join-more {
          width: 90%;
          margin: 20px auto;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/IndexMain.vue